/**
 * Deterministic facing octant: 0 = E, clockwise (doc 16 convention). No trig —
 * comparisons against tan(22.5°) only, so every platform agrees bit-for-bit.
 */

const TAN_22_5 = 0.41421356237309503; // tan(π/8) = √2 − 1

export function facingOctant(di: number, dj: number): number {
  // world tile delta → screen-space vector (iso 2:1)
  const sx = di - dj;
  const sy = (di + dj) * 0.5;
  const ax = Math.abs(sx);
  const ay = Math.abs(sy);
  if (ax === 0 && ay === 0) return 1;
  if (ay <= ax * TAN_22_5) return sx >= 0 ? 0 : 4; // E / W
  if (ax <= ay * TAN_22_5) return sy >= 0 ? 2 : 6; // S / N
  if (sx >= 0) return sy >= 0 ? 1 : 7; // SE / NE
  return sy >= 0 ? 3 : 5; // SW / NW
}
